export default __webpack_public_path__ + "static/media/cadena.3a667dd8.png";